import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import Layout from "../../components/Layout/authenticatedLayout";
import { useMsal } from "@azure/msal-react";
import Preferences from "../../components/Admin/Preferences";
import { store } from "../../state";

import { IPublicClientApplication, AccountInfo } from "@azure/msal-browser";
import ImportsDataManager from "../../components/DataManagers/ImportsDataManager";

async function fetchProfilePhoto(
  instance: IPublicClientApplication,
  account: AccountInfo,
) {
  // Acquire token for Microsoft Graph
  const tokenResponse = await instance.acquireTokenSilent({
    scopes: ["User.Read"],
    account,
  });
  const accessToken = tokenResponse.accessToken;

  // Fetch profile photo from Microsoft Graph
  const response = await fetch(
    "https://graph.microsoft.com/v1.0/me/photo/$value",
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
  if (response.ok) {
    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);
    return imageUrl;
  }
  return null;
}

function HomePage() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const username = store.getState().permissions.username;
  const role = store.getState().permissions.role;

  const initials = (() => {
    if (!username) return "?";
    const words = username.trim().split(/\s+/);
    if (words.length === 1) return words[0][0]?.toUpperCase() || "#";
    return (
      (words[0][0] || "").toUpperCase() +
        (words[words.length - 1][0] || "").toUpperCase() || "#"
    );
  })();

  const [profilePhoto, setProfilePhoto] = useState<string | null>(null);

  useEffect(() => {
    let didRun = false;
    if (instance && account && !didRun) {
      didRun = true;
      fetchProfilePhoto(instance, account).then((url) => {
        setProfilePhoto(url);
      });
    }
  }, []);

  return (
    <Layout title={"Home"} showVersion={true}>
      <ImportsDataManager />
      <div className={styles.container}>
        <div className={styles.preferencesWrapper}>
          <Preferences />
        </div>
        <div className={styles.center}>
          {profilePhoto ? (
            <img
              src={profilePhoto}
              alt="Profile"
              className={styles.profilePhoto}
            />
          ) : (
            <div className={styles.profilePhotoPlaceholder}>{initials}</div>
          )}

          {username ? (
            <div className={styles.greeting}>Hello, {username}!</div>
          ) : (
            <div className={styles.greeting}>Hello!</div>
          )}
          {role ? (
            <div className={styles.role}>Your role is {role}</div>
          ) : (
            <div className={styles.role}>You are not logged in</div>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default HomePage;
